module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 0",
      "background": "#fff"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "公司名称",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "short_name",
      "fixed": "",
      "label": "公司别名",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_point",
      "fixed": "",
      "label": "发票类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.invoice_type == 1 ? '普通发票' : '增值发票'))]), _vm._v(" "), (scope.row.tax_point > 0) ? _c('span', [_vm._v("(" + _vm._s(scope.row.tax_point) + "%)")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_key",
      "fixed": "",
      "label": "结算类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.type == 1 ? '对公' : '对私'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加公司' : '编辑公司',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "type", $$v)
      },
      expression: "chooseProduct.type"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业别名",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入企业别名"
    },
    model: {
      value: (_vm.chooseProduct.short_name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "short_name", $$v)
      },
      expression: "chooseProduct.short_name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.type == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入个人名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入统一社会信用码"
    },
    model: {
      value: (_vm.chooseProduct.social_credit_code),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "social_credit_code", $$v)
      },
      expression: "chooseProduct.social_credit_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册地址"
    },
    model: {
      value: (_vm.chooseProduct.company_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_addr", $$v)
      },
      expression: "chooseProduct.company_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入注册电话"
    },
    model: {
      value: (_vm.chooseProduct.company_phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "company_phone", $$v)
      },
      expression: "chooseProduct.company_phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开票信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chooseProduct.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "发票类型",
      "prop": "invoice_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.invoice_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "invoice_type", $$v)
      },
      expression: "chooseProduct.invoice_type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "opening_bank"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入开户行"
    },
    model: {
      value: (_vm.chooseProduct.opening_bank),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "opening_bank", $$v)
      },
      expression: "chooseProduct.opening_bank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款账号",
      "prop": "receiving_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入收款账号"
    },
    model: {
      value: (_vm.chooseProduct.receiving_account),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "receiving_account", $$v)
      },
      expression: "chooseProduct.receiving_account"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "税点"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseProduct.tax_point),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "tax_point", $$v)
      },
      expression: "chooseProduct.tax_point"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3.36",
    attrs: {
      "label": "3.36",
      "value": "3.36"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "6.72",
    attrs: {
      "label": "6.72",
      "value": "6.72"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件信息"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入联系人"
    },
    model: {
      value: (_vm.chooseProduct.contact),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "contact", $$v)
      },
      expression: "chooseProduct.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮寄地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入邮寄地址"
    },
    model: {
      value: (_vm.chooseProduct.email_addr),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "email_addr", $$v)
      },
      expression: "chooseProduct.email_addr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入电话"
    },
    model: {
      value: (_vm.chooseProduct.phone),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "phone", $$v)
      },
      expression: "chooseProduct.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.chooseProduct.remark),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "remark", $$v)
      },
      expression: "chooseProduct.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-79b75738"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/company/cpcompanylist.vue
// module id = 569
// module chunks = 1